import * as yup from 'yup';

export const MaquinaDetalheSchemas = yup.object().shape({
    Marca: yup.string().required('Campo marca é obrigatório'),
    Modelo: yup.string().required('Campo modelo é obrigatório'),
    NumeroSerie: yup.string().required('Campo número de série é obrigatório'),
    // Obrigatório só para máquina NOVA, por decisão do usuário. As que já existem
    // ficam sem tipo: aparecem em branco na coluna e o filtro por Tipo não as
    // encontra até alguém classificar. Como este schema também valida a EDIÇÃO,
    // abrir uma máquina antiga e salvar vai exigir escolher o tipo - o que é o
    // caminho natural para o acervo ir sendo classificado com o uso.
    TipoMaquina: yup.string().required('Campo tipo é obrigatório'),
});
